module.exports = __webpack_public_path__ + "assets/asian_mobile-065f42.svg";